import React, { forwardRef } from 'react'
import '../../styles/index.scss'
import { dataSystem, systemArray, linkData, dataFlipingSytem } from '../../data/data-intro'
import down from '../../assets/images/system/down.png'
import bao1 from '../../assets/images/system/bao1.png'
import bao2 from '../../assets/images/system/bao2.png'
import bao3 from '../../assets/images/system/box.png'
import './system.scss'
import img from '../../assets/images/system/brush.png'

import arrow from '../../assets/images/system/arrow.png'
import useHover from '../../components/hook/useHover'
import './card.scss'

const SystemPage = (props, ref) => {
    const array = [bao1, bao2, bao3]
    const [hoverRef1, isHovered1] = useHover();
    const [hoverRef2, isHovered2] = useHover();
    const [hoverRef3, isHovered3] = useHover();

    const [hoverRef4, isHovered4] = useHover();
    const [hoverRef5, isHovered5] = useHover();
    const [hoverRef6, isHovered6] = useHover();

    const [hoverRef1x, isHovered1x] = useHover();
    const [hoverRef2x, isHovered2x] = useHover();
    const [hoverRef3x, isHovered3x] = useHover();

    const [hoverRef4x, isHovered4x] = useHover();
    const [hoverRef5x, isHovered5x] = useHover();
    const [hoverRef6x, isHovered6x] = useHover();

    const _refHoverItemCartRow1x = (key) => {
        switch (key) {
            case 0: {
                return hoverRef1x;
            }
            case 1: {

                return hoverRef2x;
            }
            case 2: {
                return hoverRef3x;
            }
            case 3: {
                return hoverRef4x;
            }
            case 4: {
                return hoverRef5x;
            }
            case 5: {
                return hoverRef6x;
            }
        }
    }

    const _isHoverItemCartRow1x = (key) => {
        switch (key) {
            case 0: {

                return isHovered1x;
            }
            case 1: {

                return isHovered2x;
            }
            case 2: {

                return isHovered3x;
            }
            case 3: {

                return isHovered4x;
            }
            case 4: {

                return isHovered5x;
            }
            case 5: {

                return isHovered6x;
            }
        }
    }



    const _refHoverItemCartRow1 = (key) => {
        switch (key) {
            case 0: {

                return hoverRef1;
            }
            case 1: {

                return hoverRef2;
            }
            case 2: {

                return hoverRef3;
            }
        }
    }


    const _isHoverItemCartRow1 = (key) => {
        switch (key) {
            case 0: {

                return isHovered1;
            }
            case 1: {

                return isHovered2;
            }
            case 2: {

                return isHovered3;
            }
        }
    }

    const _refHoverItemCartRow2 = (key) => {
        switch (key) {
            case 0: {

                return hoverRef4
            }
            case 1: {

                return hoverRef5;
            }
            case 2: {

                return hoverRef6;
            }
        }
    }


    const _isHoverItemCartRow2 = (key) => {
        switch (key) {
            case 0: {

                return isHovered4;
            }
            case 1: {

                return isHovered5;
            }
            case 2: {

                return isHovered6;
            }
        }
    }

    return (
        <div ref={ref} >
            <div className='systemNP-mobile-brush' >
                <img loading="lazy" src={img} alt="brush" style={{ width: '100%' }} />
                <div className="container" >
                    <div className="systemNP-header-mobile">
                        <div className='systemNP-mobile-title' style={{ paddingBottom: 0 }}>
                            {dataSystem.title1}
                        </div>
                        <div className='systemNP-mobile-title'>
                            {dataSystem.title2}
                        </div>
                    </div>
                </div>
            </div>
            <div className="systemNP-mobile systemNP-large">
                <div className="container">
                    <div className="systemNP-mobile-top">
                        <div className="systemNP-header-large">
                            <div className='systemNP-mobile-title'>
                                {dataSystem.title}
                            </div>
                        </div>
                        <div>
                            <a className='systemNP-mobile-docs' target="_blank" rel="noreferrer"
                                href={linkData}>
                                <img loading="lazy" src={down} alt="down" />
                                <p> Tài liệu kỹ thuật</p>
                            </a>
                        </div>
                    </div>

                    <div className='systemNP-mobile-step'>
                        {
                            systemArray.map((value, index) => (
                                <>
                                    <div key={`${index}-${value.step}`} className={`systemNP-mobile-step-item flex${index + 1}`}
                                    >
                                        <div className='systemNP-mobile-step-item-cover' >
                                            <img src={array[index]} className={`bao${index + 1}`} />
                                            <div className='systemNP-mobile-step-item-text' >
                                                <h4>   {value.step}</h4>
                                                <p>   {value.content}</p>
                                            </div>
                                        </div>

                                        {
                                            index != 2 && <img loading="lazy" src={arrow} alt="arrow" className='systemNP-mobile-step-item-img' />
                                        }
                                    </div>
                                </>
                            ))
                        }

                    </div>

                    <div className='systemNP-mobile-instruction' >

                        <div className="systemNP-mobile-cover">
                            {
                                dataFlipingSytem.slice(0, 3).map((value, index) => (
                                    <div className={`flip-container first ${_isHoverItemCartRow1(index) ? "hover" : ""}`} key={`${index}-${value.fe}-${value.be}`} ref={_refHoverItemCartRow1(index)}>
                                        <div className="flipper">
                                            <div className={`front ${value.fe === "Dụng cụ thi công" ? "customize" : ""}`}>
                                                {value.fe}
                                            </div>
                                            <div className="back">
                                                <p>  {value.be}</p>
                                            </div>
                                        </div>
                                    </div>

                                ))
                            }
                        </div>

                        <div className="systemNP-mobile-cover" style={{ paddingBottom: 50 }}>
                            {
                                dataFlipingSytem.slice(3, 6).map((value, index) => (
                                    <div className={`flip-container ${_isHoverItemCartRow2(index) ? "hover" : ""}`} key={`${index + 1}-${value.fe}-${value.be}-${value.be1}`} ref={_refHoverItemCartRow2(index)}>
                                        <div className="flipper">
                                            <div className="front">
                                                <p> {value.fe}</p>
                                            </div>
                                            <div className="back">
                                                {index !== 2 ? <p> {value.be}</p> :
                                                    <div style={{ display: 'flex', flexDirection: 'column', textAlign: 'left', padding: '8px' }}>
                                                        <p> {value.be}</p>
                                                        <p>{`${value.be1}`}</p>
                                                        <p> {value.be2}</p>
                                                    </div>}
                                            </div>
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                </div>
            </div>

            <div className="systemNP-mobile-div">
                <div className="container">
                    {
                        dataFlipingSytem.slice(0, 6).map((value, index) => (
                            <div className={`flip-card ${_isHoverItemCartRow1x(index) ? "hover" : ""}`} key={`${index + 1}-${value.fe}-${value.be}-${value.be1}`} ref={_refHoverItemCartRow1x(index)}>
                                <div className="flip-card-inner">
                                    <div className={`flip-card-front`}>
                                        {value.fe}
                                    </div>
                                    <div className={`flip-card-back`}>
                                        {value?.be && <p> {value?.be}</p>}
                                        {value?.be1 && <p> {value?.be1}</p>}
                                        {value?.be2 && <p> {value?.be2}</p>}
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                </div>

            </div>
        </div>
    )

}

export default forwardRef(SystemPage)
